module.exports = __webpack_public_path__ + "static/media/AmazonJPGraphics1.27cd557c.jpg";